<template>
    <div class="quality-registration">
        <v-row>
            <v-col>
                <loader v-if="loading" />
                <v-card v-else>
                    <v-card-text>
                        <v-subheader>
                            <v-row>
                                <v-col>
                                    Navn
                                </v-col>
                                <v-col>
                                    Ajour
                                </v-col>
                                <v-col v-if="department === 'alka'">
                                    Nysalg brutto
                                </v-col>
                                <v-col v-if="department === 'alka'">
                                    Ændringer brutto
                                </v-col>
                                <v-col v-if="department === 'tryg'">
                                    Nettosalg
                                </v-col>
                                <v-col>
                                    Annullering
                                </v-col>
                                <v-col>
                                    Nedsættelser
                                </v-col>
                                <v-col>
                                    Røde indbakker
                                </v-col>
                                <v-col>
                                    Total indbakker
                                </v-col>
                                <v-col>
                                    Rediger sager
                                </v-col>
                            </v-row>
                        </v-subheader>
                        <v-divider />
                        <v-virtual-scroll height="70vh" item-height="64" :items="filteredAgents" bench="20" class="striped-scroll">
                            <template v-slot:default="{ item: agent }">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-row align="baseline">
                                            <v-col>
                                                {{ agent.name }}
                                            </v-col>
                                            <v-col>
                                                <div class="input-wrapper">
                                                    <v-text-field @blur="agentChanged(agent)" type="number" dense single-line hide-details v-model="agent.ajour" />
                                                </div>
                                            </v-col>
                                            <v-col v-if="department === 'alka'">
                                                <div class="input-wrapper">
                                                    <v-text-field @blur="agentChanged(agent)" type="number" dense single-line hide-details v-model="agent.grossNew" />
                                                </div>
                                            </v-col>
                                            <v-col v-if="department === 'alka'">
                                                <div class="input-wrapper">
                                                    <v-text-field @blur="agentChanged(agent)" type="number" dense single-line hide-details v-model="agent.grossAdjusted" />
                                                </div>
                                            </v-col>
                                            <v-col v-if="department === 'tryg'">
                                                <div class="input-wrapper">
                                                    <v-text-field @blur="agentChanged(agent)" type="number" dense single-line hide-details v-model="agent.realized" />
                                                </div>
                                            </v-col>
                                            <v-col>
                                                <div class="input-wrapper">
                                                    <v-text-field @blur="agentChanged(agent)" type="number" dense single-line hide-details v-model="agent.canceled" />
                                                </div>
                                            </v-col>
                                            <v-col>
                                                <div class="input-wrapper">
                                                    <v-text-field @blur="agentChanged(agent)" type="number" dense single-line hide-details v-model="agent.adjusted" />
                                                </div>
                                            </v-col>
                                            <v-col>
                                                <div class="input-wrapper">
                                                    <v-text-field @blur="agentChanged(agent)" type="number" dense single-line hide-details v-model="agent.redInboxes" />
                                                </div>
                                            </v-col>
                                            <v-col>
                                                <div class="input-wrapper">
                                                    <v-text-field @blur="agentChanged(agent)" type="number" dense single-line hide-details v-model="agent.inboxes" />
                                                </div>
                                            </v-col>
                                            <v-col>
                                                <v-btn depressed color="primary" @click="selectedAgent = agent; showEditComplaintsDialog = true">
                                                    <v-icon left>fa-pen</v-icon>
                                                    Sager
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-virtual-scroll>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-if="selectedAgent" v-model="showEditComplaintsDialog" width="1000" persistent>
            <v-card>
                <v-card-title>
                    <v-row>
                        <v-col>
                            Rediger sager for {{ selectedAgent.name }}
                        </v-col>
                        <v-col class="text-right">
                            <v-btn depressed color="primary" class="white--text mr-4" @click="showEditComplaintCategoriesDialog = true">
                                <v-icon left>fa-pen</v-icon>
                                Rediger kategorier
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-divider />
                <v-card-text style="height: 65vh">
                    <v-row>
                        <v-col>
                            <v-subheader>Sager</v-subheader>
                            <loader v-if="loadingComplaints" />
                            <v-list v-else>
                                <v-list-item-group v-model="selectedComplaintIndex">
                                    <v-list-item v-for="(complaint, index) in selectedAgent.complaints" :key="index">
                                        <v-list-item-title>
                                            {{ complaint.category || 'Ny sag' }}
                                        </v-list-item-title>
                                        <v-list-item-icon>
                                            <v-icon v-if="!complaint.category || !complaint.campaign" color="red">
                                                fa-exclamation-triangle
                                            </v-icon>
                                            <v-icon v-else color="green">
                                                fa-check
                                            </v-icon>
                                        </v-list-item-icon>
                                    </v-list-item>
                                </v-list-item-group>
                                <v-list-item @click="addComplaint">
                                    <v-list-item-title>Tilføj sag</v-list-item-title>
                                    <v-list-item-icon>
                                        <v-icon>fa-plus</v-icon>
                                    </v-list-item-icon>
                                </v-list-item>
                            </v-list>
                        </v-col>
                        <v-col>
                            <v-subheader v-if="selectedComplaint"></v-subheader>
                            <v-subheader v-else>Vælg en sag til venstre eller tilføj en ny for at redigere den.</v-subheader>
                            <v-form v-if="selectedComplaint" style="padding-top: 8px;">
                                <v-autocomplete
                                    autocomplete="off"
                                    v-model="selectedComplaint.category"
                                    :error-messages="!selectedComplaint.category ? ['Du skal angive sagens kategori'] : []"
                                    outlined
                                    label="Kategori"
                                    :items="$store.state.quality.complaintCategories"
                                />
                                <v-autocomplete
                                    autocomplete="off"
                                    v-model="selectedComplaint.campaign"
                                    :error-messages="!selectedComplaint.campaign ? ['Du skal angive sagens kampagne'] : []"
                                    outlined
                                    label="Kampagne"
                                    :items="$store.state.quality.campaigns"
                                />
                                <v-textarea v-model="selectedComplaint.comment" outlined label="Kommentar" />
                                <v-btn @click="selectedAgent.complaints.splice(selectedComplaintIndex, 1)" depressed outlined color="red" class="white--text">
                                    <v-icon left>fa-trash-alt</v-icon>
                                    Slet sag
                                </v-btn>
                            </v-form>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider />
                <v-card-actions class="justify-end">
                    <v-btn class="red--text" text @click="showEditComplaintsDialog = false; selectedAgent = null">Annuller</v-btn>
                    <v-btn class="green--text" text @click="updateComplaints" :loading="submitting">Gem ændringer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showEditComplaintCategoriesDialog" width="500">
            <v-card>
                <v-card-title>Rediger sags-kategorier</v-card-title>
                <v-divider />
                <v-card-text>
                    <v-list class="striped-list">
                        <v-list-item v-for="(category, categoryIndex) in $store.state.quality.complaintCategories" :key="category">
                            <v-list-item-title>
                                <v-row align="center">
                                    <v-col>
                                        {{ category }}
                                    </v-col>
                                    <v-col class="text-right">
                                        <v-icon v-if="submitting" small color="red" class="fa-spin">fa-spinner</v-icon>
                                        <v-icon v-else right color="red" small @click="deleteCategory(category, categoryIndex)">fa-trash-alt</v-icon>
                                    </v-col>
                                </v-row>
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title>
                                <v-row align="center">
                                    <v-col>
                                        <v-text-field dense hide-details single-line v-model="newComplaintCategory" />
                                    </v-col>
                                    <v-col class="text-right">
                                        <v-btn depressed color="green" class="white--text" @click="createComplaintCategory" :loading="submitting">
                                            <v-icon left>fa-plus</v-icon>
                                            Tilføj kategori
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

export default {
    data () {
        return {
            newComplaintCategory: null,
            selectedAgent: null,
            selectedComplaintIndex: null,
            showEditComplaintsDialog: false,
            showEditComplaintCategoriesDialog: false,
            loading: false,
            loadingComplaints: false,
            submitting: false,
            agents: null
        }
    },
    computed: {
        filteredAgents () {
            if (!this.agents) return []
            return this.agents.filter(agent => {
                return agent.name.toLowerCase().includes(this.$store.state.quality.searchString.toLowerCase())
            })
        },
        selectedComplaint () {
            return this.selectedAgent.complaints[this.selectedComplaintIndex]
        },
        department () {
            return this.$store.getters['quality/department']
        },
        year () {
            return this.$store.state.quality.year
        },
        startWeek () {
            return this.$store.state.quality.startWeek
        },
        endWeek () {
            return this.$store.state.quality.endWeek
        },
        team () {
            return this.$store.state.quality.team
        },
        searchString () {
            return this.$store.state.quality.searchString
        },
        inactive () {
            return this.$store.state.quality.inactive
        },
    },
    methods: {
        async createComplaintCategory () {
            this.submitting = true
            const response = await this.$http().post('quality/registration/complaintCategory', {
                name: this.newComplaintCategory
            })
            if (response.status === 201) {
                this.$store.state.quality.complaintCategories.push(this.newComplaintCategory)
                this.newComplaintCategory = null
            }
            this.submitting = false
        },
        async deleteCategory (categoryName, categoryIndex) {
            this.submitting = true
            const response = await this.$http().delete(`quality/registration/complaintCategory/${categoryName}`)
            if (response.status === 200) {
                this.$store.state.quality.complaintCategories.splice(categoryIndex, 1)
            }
            this.submitting = false
        },
        addComplaint () {
            if (!this.selectedAgent.complaints) this.selectedAgent.complaints = []
            this.selectedAgent.complaints.push({
                category: null,
                campaign: null,
                comment: null
            })
            this.selectedComplaintIndex = this.selectedAgent.complaints.length - 1
        },
        async agentChanged (agent) {
            const { year, startWeek } = this.$store.state.quality
            await this.$http().post('quality/registration/weekResult', {
                key: agent.uniqueId + year + startWeek,
                year,
                week: startWeek,
                userUniqueId: agent.uniqueId,
                ajour: agent.ajour,
                grossNew: agent.grossNew,
                grossAdjusted: agent.grossAdjusted,
                realized: agent.realized,
                canceled: agent.canceled,
                adjusted: agent.adjusted,
                inboxes: agent.inboxes,
                redInboxes: agent.redInboxes
            })          
        },
        async getComplaints (agent) {
            this.loadingComplaints = true
            const { data: complaints } = await this.$http().get('quality/registration/complaints', {
                params: {
                    year: this.$store.state.quality.year,
                    week: this.$store.state.quality.startWeek,
                    userUniqueId: agent.uniqueId
                }
            })
            agent.complaints = complaints
            this.loadingComplaints = false
        },
        async updateComplaints () {
            if (!this.selectedAgent.complaints.every(complaint => !complaint.invalidCategory && !complaint.invalidCampaign)) return null
            this.submitting = true
            const response = await this.$http().post('quality/registration/complaints', {
                year: this.$store.state.quality.year,
                week: this.$store.state.quality.startWeek,
                userUniqueId: this.selectedAgent.uniqueId,
                complaints: this.selectedAgent.complaints.map(({ category, campaign, comment }) => ({ category, campaign, comment }))
            })
            if (response.status === 200) {
                this.selectedAgent.complaints = response.data
            }
            this.submitting = false
            this.showEditComplaintsDialog = false
            this.selectedAgent = null
            this.selectedComplaintIndex = null
        },
        async getData () {
            this.loading = true
            const response = await this.$http().get('quality/registration', {
                params: {
                    year: this.$store.state.quality.year,
                    week: this.$store.state.quality.startWeek,
                    team: this.team,
                    department: this.department,
                    inactive: this.$store.state.quality.inactive
                }
            })
            this.agents = response.data
            this.loading = false
        }
    },
    watch: {
        selectedAgent: function () {
            this.getComplaints(this.selectedAgent)
        },
        department: function () {
            this.getData()
        },
        year: function () {
            this.getData()
        },
        startWeek: function () {
            this.getData()
        },
        endWeek: function () {
            this.getData()
        },
        team: function () {
            this.getData()
        },
        inactive () {
            this.getData()
        }
    },
    created () {
        this.$store.state.quality.searchString = ''
        this.$store.state.quality.dateType = 'single'
        this.getData()
    }
}

</script>

<style lang="scss" scoped>
.quality-registration {
    .input-wrapper {
        width: 80%;
    }
}
</style>